// extracted by mini-css-extract-plugin
export default {"playableContainer":"PlayableContainer_playableContainer__KJ8GH","gameIframe":"PlayableContainer_gameIframe__u-fpc"};